import { DropPointType, DropPointTypes } from '~/lib/data-contract/salesforce';
import { Typography, VisuallyHidden } from '~/shared/components';
import styles from './DropPointTypeFilter.module.scss';

type Props = {
    value: DropPointType;
    onChange: (value: DropPointType) => void;
};

export const DropPointTypeFilter = ({ value, onChange }: Props) => (
    <fieldset className={styles.dropPointTypeFilter}>
        <VisuallyHidden asChild>
            <legend>Afhentningsmuligheder</legend>
        </VisuallyHidden>
        {Object.values(DropPointTypes).map((type) => (
            <Typography
                key={type}
                as="label"
                variant="paragraph-S"
                weight="medium"
                className={styles.option}
            >
                <VisuallyHidden asChild>
                    <input
                        type="radio"
                        name="dropPointType"
                        checked={value === type}
                        onChange={() => onChange(type)}
                    />
                </VisuallyHidden>
                {type}
            </Typography>
        ))}
    </fieldset>
);
